const o = (t) => t ? { gridColumn: t === "full" ? "-1 / 1" : t } : void 0, l = (t, e = 4) => t ? t.toString().replace(/.(?=.{0,}$)/g, (r, n) => n < e ? r : "*") : "";
export {
  o as getGridColumnStyle,
  l as maskWithAsterisk
};
